export default "__VITE_ASSET__DnFNhWF6__"